import React from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Collapse from '@mui/material/Collapse';
import Avatar from '@mui/material/Avatar';
import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Switch from '@mui/material/Switch';
import FormControlLabel from '@mui/material/FormControlLabel';
import Divider from '@mui/material/Divider';
import { styled } from '@mui/material/styles';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import TranslateIcon from '@mui/icons-material/Translate';
import DescriptionIcon from '@mui/icons-material/Description';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import swal from 'sweetalert';
import Autocomplete from '@mui/material/Autocomplete';

import Client from './Client';
import Config from './ClientConfig';
import DropDown from './DropDown';
import KImage from './KImage';
import noImage from './../images/noImage.png';
import active_on from './../images/icons/active_on.png';
import active_off from './../images/icons/active_off.png';

const ExpandMore = styled((props) => { const { expand, ...other } = props; return <IconButton {...other} />; })(({ theme, expand }) => ({
  transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)', marginLeft: 'auto', transition: theme.transitions.create('transform', { duration: theme.transitions.duration.shortest, }),
}));

let LANGS_CACHE = null; let LANGS_BY_ID = null; let LANGS_LOADING = null;
const COUNTY_CACHE = new Map();

const StableKImage = React.memo(KImage, (prev, next) => {
  const prevData = (prev.image && prev.image.data) || '';
  const nextData = (next.image && next.image.data) || '';
  return (
    prev.edit === next.edit &&
    prevData === nextData
  );
});

export default class News extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      client: new Client('none'),
      item: {
        iref: '',
        createdOn: '',
        modifiedOn: '',
        name: '',
        description: '',
        image: null,
        dateFrom: '',
        dateTo: '',
        frequency: 0,
        county: null,
        details: '',
        detailsLanguage: 0,
        type: 1,
        isActive: true,
        pin_position: 0,
      },
      expanded: !!props.isNew,
      edit: !!props.isNew,
      allowEdit: props.allowEdit !== false,
      saveButtonVisible: false,
      tabValue: 'details',
      somethingHasChanged: false,
      isSaving: false,
      imgVersion: 0,

      translations: [],
      trEdit: {},
      languages: [],
      langById: {},
      languagesReady: false,
      isSavingTr: false,

      frequencyOptions: { 0: 'ONCE', 1: 'ONCE_A_DAY', 2: 'ONCE_A_WEEK', 3: 'ONCE_A_MONTH' },
      typeOptions: { 0: 'INTERNAL', 1: 'EXTERNAL', 2: 'BOTH' },
      detailsLangOptions: { 0: 'TEXT', 1: 'HTML', 2: 'MARKUP' },
      pinOptions: { 0: 'None', 1: '1st', 2: '2nd', 3: '3rd' },

      counties: [], countyOpts: {}, countyObj: null,
    };

    this.handleExpandClick = this.handleExpandClick.bind(this);
    this.handleEditClick = this.handleEditClick.bind(this);
    this.handleSaveClick = this.handleSaveClick.bind(this);
    this.handleTabChange = this.handleTabChange.bind(this);
    this.changeValue = this.changeValue.bind(this);
    this.pushData = this.pushData.bind(this);

    this.changeFrequency = this.changeFrequency.bind(this);
    this.changeType = this.changeType.bind(this);
    this.changeDetailsLang = this.changeDetailsLang.bind(this);
    this.changePinPosition = this.changePinPosition.bind(this);
    this.saveTranslation = this.saveTranslation.bind(this);
    this.addBlankTranslation = this.addBlankTranslation.bind(this);
    this.toggleTrEdit = this.toggleTrEdit.bind(this);

    this.getImage = this.getImage.bind(this);
    this._lastImgRaw = undefined;
    this._kimgImageObj = { data: '' };
  }

  // ---------- date helpers ----------
  toPayloadDate(raw) {
    if (!raw) return null; const s = String(raw).trim();
    let m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(s); if (m) return `${m[1]}-${m[2]}-${m[3]} 00:00:00`;
    m = /^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2})(?::(\d{2}))?$/.exec(s); if (m) return `${m[1]}-${m[2]}-${m[3]} ${m[4]}:${m[5]}:${m[6] || '00'}`;
    m = /^(\d{2})-(\d{2})-(\d{4})$/.exec(s); if (m) return `${m[3]}-${m[2]}-${m[1]} 00:00:00`;
    m = /^(\d{2})-(\d{2})-(\d{4})[ T](\d{2}):(\d{2}):(\d{2})$/.exec(s); if (m) return `${m[3]}-${m[2]}-${m[1]} ${m[4]}:${m[5]}:${m[6]}`;
    return null;
  }
  toYMD(value) { if (!value) return ''; const first = String(value).trim().split(' ')[0]; const m = /^(\d{2})-(\d{2})-(\d{4})$/.exec(first); if (!m) return ''; return `${m[3]}-${m[2]}-${m[1]}`; }
  toDMY(value) { if (!value) return ''; const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(value).trim()); if (!m) return ''; return `${m[3]}-${m[2]}-${m[1]}`; }

  hasValidDates = () => {
    const { dateFrom, dateTo } = this.state.item || {};
    if (!dateFrom || !dateTo) return false;
    const d1 = this.toPayloadDate(dateFrom);
    const d2 = this.toPayloadDate(dateTo);
    if (!d1 || !d2) return false;
    return new Date(d1) <= new Date(d2);
  };

  componentDidMount() {
    if (this.props.item) {
      const incoming = { ...this.props.item };
      this.setState({ item: incoming }, () => {
        // load counties *after* item is in state so we know the county id
        this.updateGeoData('country061', incoming.county || null);
      });
    } else {
      // ensure counties list exists even without an item yet
      this.updateGeoData('country061', this.state.item?.county || null);
    }
    this.loadLanguages();
  }
  componentDidUpdate(prevProps) {
    if (this.props !== prevProps && this.props.item) {
      const incoming = { ...this.props.item };
      this.setState({ item: incoming }, () => {
        // re-hydrate county after an external item change
        this.updateGeoData('country061', incoming.county || null);
      });
    }
  }

  // to replace "country061" with value from Config/Platform (PLATFORM_DEFAULT_COUNTRY)
  updateGeoData = (country_id = 'country061', county_id = null) => {
    // 1) serve from cache if available
    if (COUNTY_CACHE.has(country_id)) {
      const { options, dict } = COUNTY_CACHE.get(country_id);
      this.setState({ counties: options, countyOpts: dict }, () => {
        if (county_id) {
          const obj = options.find(o => o.iref === String(county_id)) || null;
          this.setState(s => ({
            countyObj: obj,
            item: { ...s.item, county: obj ? obj.iref : null }
          }));
        }
      });
      return;
    }
    // 2) fetch once, then cache
    const queryData = { country: country_id, orderBy_Name: true };
    const data = this.state.client.getData(Config.API_URL_COUNTY, queryData);

    let countiesArr = [];
    if (data && Array.isArray(data.counties)) {
      countiesArr = data.counties;
    }

    const options = countiesArr.map(f => ({
      iref: String(f.iref),
      name: String(f.name || '')
    }));

    const dict = {};
    options.forEach(f => { dict[f.iref] = f.name; });

    // cache for subsequent calls
    COUNTY_CACHE.set(country_id, { options, dict });

    this.setState({ counties: options, countyOpts: dict }, () => {
      if (county_id) {
        const obj = options.find(o => o.iref === String(county_id)) || null;
        this.setState(s => ({
          countyObj: obj,
          promotion: { ...s.promotion, county: obj ? obj.iref : null }
        }));
      }
    });
  };

  // make absolute URLs relative, so getData won't double-prefix
  toRelative = (u) => { if (!u) return ''; return String(u).replace(/^https?:\/\/[^/]+/i, ''); };
  // join base + path with exactly one slash
  joinUrl = (base, path) => {
    const b = (base || '').endsWith('/') ? base : (base + '/');
    const p = (path || '').startsWith('/') ? path.slice(1) : path;
    return b + p;
  };

  // ---------- languages & translations ----------
  async loadLanguages() {
    if (LANGS_CACHE && LANGS_BY_ID) {
      this.setState({ languages: LANGS_CACHE, langById: LANGS_BY_ID, languagesReady: true });
      return;
    }
    if (LANGS_LOADING) {
      await LANGS_LOADING;
      this.setState({ languages: LANGS_CACHE || [], langById: LANGS_BY_ID || {}, languagesReady: true });
      return;
    }
    LANGS_LOADING = (async () => {
      const urlBase = this.toRelative(this.props.API_URL_LANGUAGE || Config.API_URL_LANGUAGE || '/api/1.0/languages/');
      const data = this.state.client.getData(urlBase, {});
      const raw = Array.isArray(data?.Languages) ? data.Languages : [];
      const list = raw
        .map(x => ({ iref: String(x.iref), languageName: String(x.languageName || '').trim() }))
        .filter(x => x.iref && x.languageName);
      const map = {}; list.forEach(l => { map[l.iref] = l; });
      LANGS_CACHE = list; LANGS_BY_ID = map;
    })();
    try { await LANGS_LOADING; } finally { LANGS_LOADING = null; }
    this.setState({ languages: LANGS_CACHE, langById: LANGS_BY_ID, languagesReady: true });
  }

  async loadTranslations() {
    const id = this.state.item?.iref; if (!id) return;
    const base = this.toRelative(this.props.API_URL_NEWS || Config.API_URL_NEWS || '/api/1.0/news/');
    const url  = this.joinUrl(base, `${id}/translations/`);
    const data = this.state.client.getData(url, {});
    if (!data) { swal('Error','Could not load translations','error'); return; }

    const rows = Array.isArray(data?.translations) ? data.translations : [];
    const normalized = rows.map(r => {
      const langId = (r.language && typeof r.language === 'object')
        ? String(r.language.iref)
        : (r.language != null ? String(r.language) : null);
      return { ...r, language: langId };
    });
    this.setState({ translations: normalized });
  }

  onTrFieldChange = (iref, field, value) => {
    this.setState(s => ({ translations: (s.translations || []).map(r => String(r.iref) === String(iref) ? { ...r, [field]: value } : r) }));
  };

  saveTranslation = async (row) => {
    const newsId = this.state.item?.iref; if (!newsId) {
      swal('Error','Save the news first, then add translations.','error'); return;
    }
    this.setState({ isSavingTr: true });

    const isRealId = row.iref && Number(row.iref) > 0;
    const payload = {
      ...(isRealId ? { iref: row.iref } : {}),
      language_iref: row.language || null,
      name: (row.name ?? '').trim(),
      description: (row.description ?? '').trim(),
      details: (row.details ?? '').trim()
    };

    try {
      const base = this.toRelative(this.props.API_URL_NEWS || Config.API_URL_NEWS || '/api/1.0/news/');
      const url  = this.joinUrl(base, `${newsId}/translations_save/`);
      const data = this.state.client.pushData(url, payload); // POST via your client helper

      if (data && data.status === 'OK') {
        const saved  = data.row;
        const langId = saved?.language && typeof saved.language === 'object'
          ? String(saved.language.iref) : String(saved.language || '');
        const merged = { ...saved, language: langId || null };
        this.setState(s => {
          const list = [...s.translations];
          const idx = list.findIndex(x => x.iref === row.iref || x.iref === merged.iref);
          if (idx >= 0) list[idx] = merged; else list.unshift(merged);
          return { translations: list, isSavingTr: false, trEdit: { ...s.trEdit, [merged.iref]: false } };
        });
        swal('Saved','Translation saved.','success',{ buttons:false, timer:900 });
      } else {
        const msg = (data && (data.message || JSON.stringify(data.errors))) || 'Unknown error';
        swal('Save failed', msg, 'error'); this.setState({ isSavingTr: false });
      }
    } catch (e) {
      swal('Save failed', e.message || String(e), 'error');
      this.setState({ isSavingTr: false });
    }
  };

  addBlankTranslation = () => {
    if (this.hasOpenDraft()) {
      swal('Heads up', 'Please finish or cancel the current draft translation first.', 'info');
      return;
    }
    const tmpId = -Date.now();
    const newRow = { iref: tmpId, news: this.state.item?.iref, language: null, name: '', description: '', details: '' };
    this.setState(s => ({
      translations: [newRow, ...s.translations],
      trEdit: { ...s.trEdit, [tmpId]: true }
    }));
  };

  canEditTrRow = (t) =>
    !!this.state.allowEdit && ((this.state.trEdit && this.state.trEdit[t.iref]) || (t.iref < 0));
  
  toggleTrEdit(iref, force) {
    this.setState(s => ({
      trEdit: { ...s.trEdit, [iref]: typeof force === 'boolean' ? force : !s.trEdit?.[iref] }
    }));
  }
  
  hasOpenDraft = () => (this.state.translations || []).some(t => Number(t.iref) < 0);

  // ---------- changes ----------
  changeFrequency(v){ this.setState(s=>({ item:{...s.item, frequency: parseInt(v,10)}, somethingHasChanged:true })); }
  changeType(v){ this.setState(s=>({ item:{...s.item, type: parseInt(v,10)}, somethingHasChanged:true })); }
  changeDetailsLang(v){ this.setState(s=>({ item:{...s.item, detailsLanguage: parseInt(v,10)}, somethingHasChanged:true })); }
  changePinPosition(v){ this.setState(s => ({item: { ...s.item, pin_position: parseInt(v, 10) },somethingHasChanged: true })); }

  handleExpandClick(){ this.setState((s) => ({ expanded: !s.expanded })); }
  handleEditClick = () => {
    if (!this.state.allowEdit) return;
    this.setState(prev => {
      const img = prev.item.image || '';
      const clean = (typeof img === 'string') ? img.replace(/\s+/g, '').trim() : '';
      return { edit: !prev.edit, saveButtonVisible: !prev.edit, expanded: true, item: { ...prev.item, image: clean } };
    });
  };
  handleSaveClick = () => {
    if (document?.activeElement?.blur) {
      document.activeElement.blur();
    }
    setTimeout(() => this.pushData(), 0);
  };
  handleTabChange = async (_, tab) => {
    this.setState({ tabValue: tab }, async () => { if (tab === 'translations') { await this.loadLanguages(); if (this.state.item?.iref) await this.loadTranslations(); } });
  };

  changeValue(e){ const id = e.target.id; const value = (e.target.type === 'checkbox') ? e.target.checked : e.target.value; this.setState(s => ({ item:{...s.item, [id]: value}, somethingHasChanged:true })); }
  getImage(newImage) {
    const raw = (newImage && typeof newImage === 'object') ? (newImage.data || '') : (newImage || '');
    const dataStr = String(raw).replace(/\s+/g, ''); // strip spaces/newlines
    this.setState(s => ({ item: { ...s.item, image: dataStr }, somethingHasChanged: true }));
  }

  // ---------- save ----------
  pushData() {
    if (!(this.state.edit && this.state.somethingHasChanged)) { swal('Error', 'Nothing to save', 'error'); return; }
    if (!this.hasValidDates()) {
      swal('Missing or invalid period', 'Please select both From and To dates (From must be before To).', 'warning');
      return;
    }
    this.setState({ isSaving: true });
    try {
      const src = this.state.item; const payload = { ...src };
      delete payload.createdOn;
      delete payload.modifiedOn;
      payload.dateFrom = this.toPayloadDate(src.dateFrom); payload.dateTo = this.toPayloadDate(src.dateTo);
      const base = this.props.API_URL_NEWS || Config.API_URL_NEWS || '/api/1.0/news/';
      const r = this.state.client.pushData(base, payload);
      if (r && r.status === 'OK') {
        const next = { ...this.state.item };
        if (r.iref) next.iref = r.iref;
        if (r.createdOn) next.createdOn = r.createdOn;
        if (r.modifiedOn) next.modifiedOn = r.modifiedOn;
        if (typeof r.pin_position !== 'undefined') next.pin_position = r.pin_position;
        this.setState({
          item: next,
          somethingHasChanged: false,
          isSaving: false,
          edit: false,
          saveButtonVisible: false,
        });
        swal('Saved', 'News saved successfully.', 'success', { buttons: false, timer: 1200 });
        if (typeof this.props.onUpdated === 'function') {
          this.props.onUpdated();  // 👈 triggers full page reload/list refresh
        }
        return;
      }
      const msg = (r && (r.message || (r.errors && JSON.stringify(r.errors)))) || 'Unknown error';
      swal('Save failed', msg, 'error'); this.setState({ isSaving: false });
    } catch (e) { const msg = (e && e.message) ? e.message : String(e); swal('Save failed', msg, 'error'); this.setState({ isSaving: false }); }
  }

  isValidDataUrl = (s) => {
    if (typeof s !== 'string') return false;
    const m = s.match(/^data:image\/(png|jpe?g|gif|webp);base64,([A-Za-z0-9+/=]+)$/i);
    return !!(m && m[2] && m[2].length > 16); // crude sanity: some payload length
  };

  _onKImageSaveBack = (img) => {
    const raw = (img && typeof img === 'object') ? (img.data || '') : (img || '');
    const dataStr = String(raw).replace(/\s+/g, '');
    this.setState(s => ({
      item: { ...s.item, image: dataStr },
      somethingHasChanged: true,
      imgVersion: (s.imgVersion || 0) + 1,      
    }));
  };

  // ---------- render ----------
  render() {
    const p = this.state.item || {};
    const title = p.name || 'New News';

    let newsImage = p.image;
    if (newsImage && typeof newsImage === 'object') newsImage = newsImage.data || newsImage.url || newsImage.src || '';
    if (typeof newsImage !== 'string') newsImage = '';
    newsImage = newsImage.trim();
    if (!newsImage) {
      newsImage = noImage;
    } else {
      const isDataUrl = newsImage.startsWith('data:');
      const isHttp   = /^https?:\/\//i.test(newsImage);
      const isPath   = newsImage.startsWith('/') || newsImage.startsWith('./') || newsImage.startsWith('../');

      if (isDataUrl) {
        // validate
        if (!this.isValidDataUrl(newsImage)) newsImage = noImage;
      } else if (isHttp || isPath) {
        // add _s thumbnail suffix for file/URL images only
        try {
          const dot = newsImage.lastIndexOf('.');
          const slash = newsImage.lastIndexOf('/');
          if (dot > -1 && dot > slash) {
            const base = newsImage.slice(0, dot);
            const ext  = newsImage.slice(dot + 1);
            newsImage  = `${base}_s.${ext}`;
          }
        } catch {}
      } else {
        // anything else -> placeholder
        newsImage = noImage;
      }
    }

    const activeAvatar = p.isActive ? active_on : active_off; const activeAlt = p.isActive ? 'Active' : 'Inactive';

    const imgRaw = this.state.item?.image || '';
    if (imgRaw !== this._lastImgRaw) {
      this._kimgImageObj = { data: imgRaw };
      this._lastImgRaw = imgRaw;
    }

    const detailsEdit = (() => {
      const p = this.state?.item || {};
      if (p.type == null || !(p.type in this.state.typeOptions)) {
        p.type = 1;
      }

      return (
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', md: '220px 1fr' },
            gap: 1.25,
            alignItems: 'start',
          }}
        >
          {/* LEFT: Image */}
          <Box sx={{ width: { xs: '100%', md: 220 } }}>
            <StableKImage
              edit={this.state.edit}
              image={this._kimgImageObj}
              imageText="News image"
              saveBack={this._onKImageSaveBack}
              version={this.state.imgVersion}
              key={this.state.imgVersion}
            />
          </Box>

          {/* RIGHT: Fields */}
          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: 'repeat(12, minmax(0,1fr))',
              gap: 1,
              alignItems: 'center',
              '& .MuiFormControl-root': { m: 0 }, // tighter spacing
            }}
          >
            {/* Row 1: Active | Name | Type | Frequency */}
              <Box sx={{
                  gridColumn: { xs: '1 / -1', md: 'span 2' },
                  display: 'flex',
                  alignItems: 'center',
                  minWidth: 0,
                }}
              >
                <FormControlLabel
                  sx={{ m: 0, width: '100%' }}
                  control={
                    <Switch
                      id="isActive"
                      size="small"
                      checked={!!p.isActive}
                      onChange={(e) =>
                        this.changeValue({
                          target: { id: 'isActive', type: 'checkbox', checked: e.target.checked },
                        })
                      }
                    />
                  }
                  label="Active"
                />
              </Box>

              <Box sx={{ gridColumn: { xs: '1 / -1', md: 'span 6' }, minWidth: 0 }}>
                <TextField
                  id="name"
                  label="Name"
                  value={p.name || ''}
                  onChange={this.changeValue}
                  size="small"
                  variant="outlined"
                  fullWidth
                  inputProps={{ maxLength: 128 }}
                />
              </Box>

              <Box sx={{ gridColumn: { xs: 'span 6', md: 'span 2' }, minWidth: 0 }}>
                <Box sx={{ minWidth: 0, width: '100%' }}>
                  <DropDown
                    name="Type"
                    value={String(p.type ?? 1)}
                    size="small"
                    doptions={this.state.typeOptions}
                    hasIcons={false}
                    minWidth={0}
                    maxWidth={999}
                    onDark={false}
                    onChangeFunction={this.changeType}
                    style={{ width: '100%' }}
                  />
                </Box>
              </Box>

              <Box sx={{ gridColumn: { xs: 'span 6', md: 'span 2' }, minWidth: 0 }}>
                <Box sx={{ minWidth: 0, width: '100%' }}>
                  <DropDown
                    name="Frequency"
                    value={String(p.frequency ?? 0)}
                    size="small"
                    doptions={this.state.frequencyOptions}
                    hasIcons={false}
                    minWidth={0}
                    maxWidth={999}
                    onDark={false}
                    onChangeFunction={this.changeFrequency}
                    style={{ width: '100%' }}
                  />
                </Box>
              </Box>

              {/* Row 2: Top position | From | To | County | Details language */}
              <Box sx={{ gridColumn: { xs: 'span 12', md: 'span 2' }, minWidth: 0 }}>
                <Box sx={{ minWidth: 0, width: '100%' }}>
                  <DropDown
                    name="Top position"
                    value={String(p.pin_position ?? 0)}
                    size="small"
                    doptions={this.state.pinOptions}
                    hasIcons={false}
                    minWidth={0}
                    maxWidth={999}
                    onDark={false}
                    onChangeFunction={this.changePinPosition}
                    style={{ width: '100%' }}
                  />
                </Box>
              </Box>

              <Box sx={{ gridColumn: { xs: 'span 6', md: 'span 3' }, minWidth: 0 }}>
                <TextField
                  id="dateFrom_ui"
                  label="From"
                  type="date"
                  size="small"
                  variant="outlined"
                  fullWidth
                  value={this.toYMD(p.dateFrom)}
                  onChange={(e) =>
                    this.setState((s) => ({
                      item: { ...s.item, dateFrom: this.toDMY(e.target.value) },
                      somethingHasChanged: true,
                    }))
                  }
                  InputLabelProps={{ shrink: true }}
                  error={!p.dateFrom}
                  helperText={!p.dateFrom ? 'Required' : ''}
                />
              </Box>

              <Box sx={{ gridColumn: { xs: 'span 6', md: 'span 3' }, minWidth: 0 }}>
                <TextField
                  id="dateTo_ui"
                  label="To"
                  type="date"
                  size="small"
                  variant="outlined"
                  fullWidth
                  value={this.toYMD(p.dateTo)}
                  onChange={(e) =>
                    this.setState((s) => ({
                      item: { ...s.item, dateTo: this.toDMY(e.target.value) },
                      somethingHasChanged: true,
                    }))
                  }
                  InputLabelProps={{ shrink: true }}
                  error={!p.dateTo}
                  helperText={!p.dateTo ? 'Required' : ''}
                />
              </Box>

              <Box sx={{ gridColumn: { xs: 'span 12', sm: 'span 6', md: 'span 2' }, minWidth: 0 }}>
                <Autocomplete
                  options={this.state.counties}
                  getOptionLabel={(opt) => opt?.name || ''}
                  isOptionEqualToValue={(a, b) => a?.iref === b?.iref}
                  value={this.state.countyObj}
                  size="small"
                  onChange={(_, val) =>
                    this.setState((s) => ({
                      countyObj: val || null,
                      item: { ...s.item, county: val ? val.iref : null },
                      somethingHasChanged: true,
                    }))
                  }
                  onOpen={() => {
                    if (!this.state.counties || this.state.counties.length === 0) {
                      this.updateGeoData('country061', this.state.item?.county || null);
                    }
                  }}
                  renderInput={(params) => <TextField {...params} variant="outlined" label="County" fullWidth />}
                />
              </Box>

              <Box sx={{ gridColumn: { xs: 'span 12', sm: 'span 6', md: 'span 2' }, minWidth: 0 }}>
                <Box sx={{ minWidth: 0, width: '100%' }}>
                  <DropDown
                    name="Details language"
                    value={String(p.detailsLanguage ?? 0)}
                    size="small"
                    doptions={this.state.detailsLangOptions}
                    hasIcons={false}
                    minWidth={0}
                    maxWidth={999}
                    onDark={false}
                    onChangeFunction={this.changeDetailsLang}
                    style={{ width: '100%' }}
                  />
                </Box>
              </Box>

            {/* Row 3: Description */}
            <Box sx={{ gridColumn: '1 / -1', minWidth: 0 }}>
              <TextField
                id="description"
                label="Description"
                value={p.description || ''}
                onChange={this.changeValue}
                variant="outlined"
                fullWidth
                multiline
                rows={3}
                inputProps={{ maxLength: 1024 }}
              />
            </Box>

            {/* Row 4: Details */}
            <Box sx={{ gridColumn: '1 / -1', minWidth: 0 }}>
              <TextField
                id="details"
                label="Details"
                value={p.details || ''}
                onChange={this.changeValue}
                variant="outlined"
                fullWidth
                multiline
                rows={6}
              />
            </Box>
          </Box>
        </Box>
      );
    })();

    const detailsReadOnly = (
      <Box sx={{ p: 1, display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: 1.5 }}>
        <Box>
          <Typography variant="subtitle2">Description</Typography>
          <Typography variant="body2" color="text.secondary">{p.description || '—'}</Typography>
        </Box>
        <Box>
          <Typography variant="subtitle2">Period</Typography>
          <Typography variant="body2" color="text.secondary">{p.dateFrom ? ('From: ' + p.dateFrom) : 'From: —'}<br />{p.dateTo ? ('To: ' + p.dateTo) : 'To: —'}</Typography>
        </Box>
        <Box>
          <Typography variant="subtitle2">Meta</Typography>
          <Typography variant="body2" color="text.secondary">
            Type: {this.state.typeOptions[p.type] || '—'} •
            Frequency: {this.state.frequencyOptions[p.frequency] || '—'} •
            County: {this.state.countyOpts?.[p.county] || '—'} •
            Top: {this.state.pinOptions[p.pin_position] || 'None'}
          </Typography>
        </Box>
        <Box>
          <Typography variant="subtitle2">Details ({this.state.detailsLangOptions[p.detailsLanguage] || '—'})</Typography>
          <Typography variant="body2" color="text.secondary" sx={{ whiteSpace:'pre-wrap' }}>{p.details || '—'}</Typography>
        </Box>
      </Box>
    );

    const translationsTab = (
      <Box sx={{ p: 1, display:'grid', gridTemplateColumns:'1fr', gap: 1 }}>
        {this.state.allowEdit && this.state.item?.iref && (
          <Box sx={{ display:'flex', gap: 1, justifyContent:'flex-end' }}>
            <Button size="small" variant="outlined" onClick={this.addBlankTranslation} disabled={this.hasOpenDraft()}>Add translation</Button>
          </Box>
        )}
        {this.state.translations.length === 0 ? (
          <Typography variant="body2" color="text.secondary">No translations yet.</Typography>
        ) : (
          this.state.translations.map((t) => {
            const isTemp = (t.iref < 0);
            return (
              <Box
                key={t.iref}
                sx={{
                  p: 0.5,
                  borderRadius: 1,
                  border: '1px solid #e0e0e0',
                  display: 'grid',
                  gridTemplateColumns: '200px 1fr',
                  gap: 0.5
                }}
              >
                {/* Language */}
                <Box sx={{ display:'grid', gap: 0.25 }}>
                  {this.canEditTrRow(t) ? (
                    <Autocomplete
                      options={this.state.languages}
                      size="small"
                      disablePortal
                      getOptionLabel={(opt) => opt?.languageName || ''}
                      isOptionEqualToValue={(opt, val) => opt?.iref === val?.iref}
                      value={(this.state.languagesReady && t.language) ? (this.state.langById[t.language] || null) : null}
                      onChange={(_, val) => this.onTrFieldChange(t.iref, 'language', val ? val.iref : null)}
                      renderInput={(params) => <TextField {...params} variant="outlined" label="Language" size="small" />}
                      ListboxProps={{ sx: { maxHeight: 200, p: 0 } }}
                      sx={{ minWidth: 200, mt: 1 }}
                      disabled={!this.state.languagesReady}
                    />
                  ) : (
                    <>
                      <Typography variant="caption" color="text.secondary">Language</Typography>
                      <Typography variant="body2">
                        {!this.state.languagesReady ? '…' : (t.language ? (this.state.langById[t.language]?.languageName || '—') : '—')}
                      </Typography>
                    </>
                  )}
                </Box>

                {/* Fields */}
                <Box sx={{ display:'grid', gap: 0.25 }}>
                  {this.canEditTrRow(t) ? (
                    <Box
                      sx={{
                        display:'grid',
                        gridTemplateColumns:'1fr 2fr auto',
                        columnGap: 0.5,
                        rowGap: 0.25,
                        alignItems:'flex-start'
                      }}
                    >
                      {/* Name */}
                      <TextField
                        size="small" margin="dense" label="Name" variant="outlined"
                        value={t.name || ''} inputProps={{ maxLength: 100 }}
                        onChange={(e)=>this.onTrFieldChange(t.iref, 'name', e.target.value)}
                      />
                      {/* Description */}
                      <TextField
                        size="small" margin="dense" label="Description" variant="outlined"
                        value={t.description || ''} inputProps={{ maxLength: 1024 }}
                        onChange={(e)=>this.onTrFieldChange(t.iref, 'description', e.target.value)}
                      />
                      {/* Actions */}
                      <Box sx={{ display:'flex', gap: 0.5, justifyContent:'flex-end', mt: 2 }}>
                        <Button size="small" variant="contained" disabled={this.state.isSavingTr} onClick={()=>this.saveTranslation(t)}>
                          {this.state.isSavingTr ? 'Saving…' : (isTemp ? 'Add' : 'Save')}
                        </Button>
                        <Button size="small" onClick={()=>{
                          if (t.iref < 0) {
                            this.setState(s => ({
                              translations: (s.translations || []).filter(x => x.iref !== t.iref),
                              trEdit: { ...s.trEdit, [t.iref]: false }
                            }));
                          } else {
                            this.toggleTrEdit(t.iref, false);
                          }
                        }}>Cancel</Button>
                      </Box>

                      {/* Details (full width, below) */}
                      <TextField
                        size="small" margin="dense" fullWidth
                        label="Details" variant="outlined"
                        multiline rows={3}
                        value={t.details || ''}
                        onChange={(e)=>this.onTrFieldChange(t.iref, 'details', e.target.value)}
                        sx={{ gridColumn: '1 / span 3' }}
                      />
                    </Box>
                  ) : (
                    <>
                      <Box sx={{ display:'flex', gap: 1, flexWrap:'wrap', alignItems:'baseline' }}>
                        <Typography variant="subtitle2">{t.name || '—'}</Typography>
                        <Typography variant="body2" color="text.secondary">{t.description || '—'}</Typography>
                      </Box>
                      <Typography variant="body2" color="text.secondary" sx={{ whiteSpace:'pre-wrap' }}>
                        {t.details || '—'}
                      </Typography>
                      {this.state.allowEdit && (
                        <Box sx={{ display:'flex', justifyContent:'flex-end', mt: 0.5 }}>
                          <Button size="small" onClick={()=>this.toggleTrEdit(t.iref, true)}>Edit</Button>
                        </Box>
                      )}
                    </>
                  )}
                </Box>
              </Box>
            );
          })
        )}
      </Box>
    );

    const saveButtonVisible = (this.state.edit && this.state.somethingHasChanged);
    const subheaderParts = [];
    if (p.createdOn) subheaderParts.push(`Created: ${p.createdOn}`);
    if (p.modifiedOn) subheaderParts.push(`Modified: ${p.modifiedOn}`);

    return (
      <Card sx={{ borderRadius: '16px', m: 1 }}>
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
          <CardHeader
            // avatar={<Avatar alt={activeAlt} src={activeAvatar} title={activeAlt} />}
            avatar={          
              <Box sx={{ display: 'flex', flexDirection: 'row', width: "100%" }}>
                <Box sx={{ display: 'flex', flexDirection: 'column', width: "100%" }}>      
                  <Avatar alt={activeAlt} src={activeAvatar} title={activeAlt}>
                  </Avatar>  
                </Box>
                <Box sx={{ display: 'flex', flexDirection: 'column', width: "100%" }}>
                  {p.iref ? (
                    <Typography variant="subtitle1" color="text.secondary">
                      {p.iref}
                    </Typography>
                  ) : null}
                </Box>
              </Box> 
            }
            action={<IconButton aria-label="edit" onClick={this.handleEditClick}><EditIcon sx={{ color: this.state.edit ? '#8f241d' : '#9aa0a6' }} /></IconButton>}
            title={title}
            subheader={subheaderParts.join(' • ')}
            titleTypographyProps={{ variant: 'h6', sx: { fontWeight: 600 } }}
          />

          <Box sx={{ display: 'flex', flexDirection: 'row' }}>
            <CardMedia component="img" height="120" sx={{ width: 128, ml: 1, borderRadius: 1 }} src={newsImage} alt={title} onError={(e)=>{ e.currentTarget.src = noImage; }}/>

            <Box sx={{ flexDirection: 'column', justifyContent: 'right', width: '100%' }}>
              <CardActions disableSpacing sx={{ display: 'block', textAlign: 'end' }}>
                <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', pt: '8px', gap: 1 }}>
                  {this.state.edit ? (
                    <Button
                      variant="contained"
                      size="small"
                      startIcon={<SaveIcon />}
                      disabled={this.state.isSaving || !saveButtonVisible || !this.hasValidDates()}
                      onClick={this.handleSaveClick}
                    >
                      {this.state.isSaving ? 'Saving…' : 'Save'}
                    </Button>
                  ) : (
                    <Typography variant="body2" color="text.secondary">
                      {p.dateFrom ? `From: ${p.dateFrom}` : 'From: —'}
                      {p.dateTo ? ` → ${p.dateTo}` : ''}
                      {p.pin_position > 0 ? (<span style={{ fontWeight: 600 }}>{` • Top: ${this.state.pinOptions[p.pin_position]}`} </span>): ''}
                    </Typography>
                  )}
                </Box>

                <ExpandMore expand={this.state.expanded} onClick={this.handleExpandClick} aria-expanded={this.state.expanded} aria-label="show more">
                  <ExpandMoreIcon />
                </ExpandMore>
              </CardActions>
            </Box>
          </Box>

          <Collapse in={this.state.expanded} timeout="auto" unmountOnExit>
            <CardContent sx={{ pt: '8px' }}>
              <Box sx={{ width: '100%' }}>
                <Tabs value={this.state.tabValue} onChange={this.handleTabChange} centered indicatorColor="secondary">
                  <Tab label="Details" value="details" icon={<DescriptionIcon />} iconPosition="start" />
                  <Tab label="Translations" value="translations" icon={<TranslateIcon />} iconPosition="start" />
                </Tabs>
                <Divider sx={{ mb: 1 }} />
                {this.state.tabValue === 'details' ? (this.state.edit ? detailsEdit : detailsReadOnly) : translationsTab}
              </Box>
            </CardContent>
          </Collapse>
        </Box>
      </Card>
    );
  }
}
